export default __webpack_public_path__ + "static/media/apple.7719c05c.jpg";